//- rating-stars on profile
$(".my-rating").starRating({
  totalStars: 5,
  starShape: 'rounded',
  starSize: 30,
  emptyColor: '#e0e0e0',
  hoverColor: '#0d400d',
  activeColor: '#0d400d',
  ratedColor: '#0d400d',
  useGradient: false,
  disableAfterRate: false,
  callback: function (currentRating, $el) {
    if ($('#review_value--input').length) {
      $('#review_value--input').attr("value", currentRating);
    }
    else {
      $('#review-value').append('<input id="review_value--input" type="hidden" name="rate" value="' + currentRating + '">');
    }
  }
});

//- Single STD Rating display
$('.std_single--rating').starRating({
  totalStars: 5,
  starShape: 'rounded',
  starSize: 20,
  readOnly: true,
  activeColor: '#0d400d',
  ratedColor: '#0d400d',
  useGradient: false,
  disableAfterRate: false
});